import firestore from "@/firebase/db";
import Monitoring from "@/utils/monitoring";
const collectionName = "user_guide";
import { Timestamp } from "firebase/firestore";

interface UserGuide {
  id: string;
  userId: string;
  docReviewTourCompletedAt?: Timestamp | null;
}

interface UserGuideService {
  getUserGuide: (userId: string) => Promise<UserGuide | null>;
  upsertUserGuide: (userId: string, data: Partial<UserGuide>) => Promise<void>;
}

export const userGuideService: UserGuideService = {
  async getUserGuide(userId: string) {
    try {
      const userGuideDoc = await firestore.get(collectionName, {
        where: [["userId", "==", userId]],
      });
      if (userGuideDoc.length > 0) {
        return userGuideDoc[0] as UserGuide;
      }
      return null;
    } catch (error: any) {
      Monitoring.trackError(error as Error, {
        function: "getUserGuide",
        userId,
        errorCode: error.code,
      });
      return null;
    }
  },

  async upsertUserGuide(userId: string, data: Partial<UserGuide>) {
    try {
      const existingUserGuide = await this.getUserGuide(userId);
      if (existingUserGuide) {
        await firestore.update(
          `${collectionName}/${existingUserGuide.id}`,
          data
        );
      } else {
        // Create new user guide
        await firestore.create(collectionName, {
          userId,
          ...data,
          createdAt: Timestamp.now(),
        });
      }
    } catch (error: any) {
      Monitoring.trackError(error as Error, {
        function: "upsertUserGuide",
        userId,
        errorCode: error.code,
      });
    }
  },
};
